import React, { useEffect, useState } from "react";
import useMasterSetting from "../../../../hooks/useMasterSetting";
import moment from "moment";
type props = {
  LRTempCode: any;
  leaveTypeTable: any;
};
const MCTypeComponent = ({ LRTempCode, leaveTypeTable }: props) => {
  const { masterSetting } = useMasterSetting();
  const [cols, setCols] = useState<any>({});
  useEffect(() => {

    if (LRTempCode) {

      const allTitles = LRTempCode.Value5.split("\n");

      const enTitle = allTitles[0]?.split("|");
      const thTitle = allTitles[1]?.split("|");
      setCols({ enTitle, thTitle });
    }
  }, [LRTempCode]);

  return (
    <div style={{ display: "flex", padding: "17px 0px 30px 0px" }}>
      <table className="table-layout-create-control table-striped">
        <thead className="thead-light">
          <tr className="set-bg-color-table-create-control">
            <th style={{ width: "5%" }}>
              <p className="row headtext"></p>
              <p className="row subtext">#</p>
            </th>
            {cols?.enTitle?.map((e: any, idx: any) => {
              return (
                <th style={{ width: idx === 0 ? "50%" : "15%" }}>
                  <p className="row headtext">{e}</p>
                  <p className="row subtext">{cols.thTitle[idx]}</p>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(leaveTypeTable)&&leaveTypeTable?.map((_data: any, idx: any) => (
            <>
              <tr>
                <td>{idx + 1}</td>
                <td>{_data.Value2}</td>
                <td>{Number(_data.Value3).toLocaleString()}</td>
                <td>{Number(_data.Value4).toLocaleString()}</td>
                <td>{Number(_data.Value5).toLocaleString()}</td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MCTypeComponent;
